import type { User } from '../firebase/firebase';
import { PayrollType } from '../models/Integrations/PayrollIntegration';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestReturnSuccessStatus,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

type PayrollTokensTequestBody = {
	payrollType: PayrollType;
	token: string;
};

export const fetchPayrollTokens = async (
	abortSignal: AbortSignal,
	user: User,
	code: string,
	payrollType: PayrollType,
): Promise<boolean | undefined> => {
	return await makeCloudFunctionRequestReturnSuccessStatus<PayrollTokensTequestBody>(
		{
			abortSignal,
			user,
			url: HTTPSCloudFunctionURLs.PayrollTokens,
			method: 'POST',
			services: defaultCloudFunctionServices,
			body: { token: code, payrollType: payrollType },
		},
	);
};
